import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';

@Component({
  selector: 'app-epc-payment',
  templateUrl: './epc-payment.component.html',
  styleUrls: ['./epc-payment.component.scss']
})
export class EpcPaymentComponent implements OnInit {
  constructor(
    private route: ActivatedRoute, 
    private cryptoJsService: CryptoJsService, 
    private router: Router,
    private activityRecordService: ActivityRecordService
    ) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;
  userID: any;

  ngOnInit() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;


    let parentRoute = this.router.url.split('/')[1];

    this.route.queryParams
      .subscribe(params => {
        this.autoId = params.autoId;
        this.appId = params.appId;
        this.items = [
          { label: 'JE Physical Verification', routerLink: `/${parentRoute}/epc/pv-done`},
          { label: 'Ready For Payment', routerLink: `/${parentRoute}/epc/ready-for-payment`},
          // { label: 'e-Sparsh Payment', routerLink: `/${parentRoute}/epc/e-sparsh`},
          // { label: 'PFMS Payment Status', routerLink: `/${parentRoute}/epc/pfms-payment-status` },          
          { label: 'Generated Lot', routerLink: `/${parentRoute}/epc/epc-generated-lot` },
        ];
      }
      );

  }
}
